import React, { useState, useEffect, useMemo } from "react";
import { useSiteContext } from "../Providers/SSCProvider";
import { useLocation } from "react-router-dom";
import { Spinner, Table, Container, Form, Row, Col } from "react-bootstrap";
import CircuitMap from "./CircuitMap";
import "./SiteMap.css";
import Icon from "../../generic/Icon";
import Map, { Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import useApi from "../../../apiProvider";
import styles from "../../generic/css/Table.module.css";

const MAPBOX_TOKEN =
  "pk.eyJ1Ijoic3RlZmFuLW0iLCJhIjoiY21mbDVwMWljMDFsZzJsczU4NGFzYXc1eSJ9.Pqi9hlSGD_ZMueCYlji_RA";

const SiteMap = () => {
  const location = useLocation();
  const [selectedSite, setSelectedSite] = useState(null);
  const [siteLogoError, setSiteLogoError] = useState(false);
  const [selectedStructureId, setSelectedStructureId] = useState("");
  const [selectedCircuit, setSelectedCircuit] = useState(null);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 3000);
  const [carrierLogoError, setCarrierLogoError] = useState(false);
  const [contacts, setContacts] = useState([]);
  const params = new URLSearchParams(location.search);
  const siteId = params.get("siteId");
  const { formData, globalSitesData } = useSiteContext();
  const carrierObj = formData?.carrier?.find(
    (c) =>
      c.carrierName?.trim().toLowerCase() ===
      selectedCircuit?.carrier?.trim().toLowerCase(),
  );

  useEffect(() => {
    if (siteId && globalSitesData && globalSitesData.length > 0) {
      const result = globalSitesData.find(
        (site) => String(site.siteId) === String(siteId),
      );
      if (result) {
        setSelectedSite(result);
      }
    }
  }, [siteId, globalSitesData]);

  useEffect(() => {}, [selectedSite]);

  useEffect(() => {
    if (
      selectedSite &&
      selectedSite.structures &&
      selectedSite.structures.filter(
        (structure) =>
          Array.isArray(structure.circuits) && structure.circuits.length > 0,
      ).length === 1
    ) {
      const onlyStructure = selectedSite.structures.find(
        (structure) =>
          Array.isArray(structure.circuits) && structure.circuits.length > 0,
      );
      if (
        onlyStructure &&
        selectedStructureId !== String(onlyStructure.structureId)
      ) {
        setSelectedStructureId(String(onlyStructure.structureId));
      }
    }
  }, [selectedSite, selectedStructureId]);

  useEffect(() => {
    const handleResize = () => setIsWideScreen(window.innerWidth >= 3000);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setCarrierLogoError(false);
  }, [selectedCircuit]);

  useEffect(() => {
    console.log("Contacts to display:", contacts);
  }, [contacts]);

  const circuits = useMemo(() => {
    if (!selectedSite || !selectedSite.structures) return [];
    if (!selectedStructureId) {
      // All circuits from all structures
      return selectedSite.structures.flatMap(
        (structure) => structure.circuits || [],
      );
    }
    // Circuits for the selected structure only
    const structure = selectedSite.structures.find(
      (s) => s.structureId === Number(selectedStructureId),
    );
    return structure ? structure.circuits || [] : [];
  }, [selectedSite, selectedStructureId]);

  const selectedStructure = useMemo(() => {
    if (!selectedSite || !selectedSite.structures) return null;
    return (
      selectedSite.structures.find(
        (s) => s.structureId === Number(selectedStructureId),
      ) || null
    );
  }, [selectedSite, selectedStructureId]);

  // Dummy handler for circuit click
  const populateSidePanel = (circuitId) => {
    console.log("Clicked circuit:", circuitId);
    setSelectedCircuit(
      circuits.find((c) => c.circuitGmId === circuitId) || null,
    );
    console.log(
      "Selected circuit:",
      circuits.find((c) => c.circuitGmId === circuitId) || null,
    );
    getContactsforCarrier(
      circuits.find((c) => c.circuitGmId === circuitId) || null,
    );
  };

  const getContactsforCarrier = async (selectedCircuit) => {
    if (selectedCircuit?.carrier?.length > 0) {
      let result = await useApi.getContactsByCarrierName(
        selectedCircuit.carrier,
      );
      console.log("Fetched contacts:", result);
      setContacts([]);
      if (result && Array.isArray(result)) {
        setContacts(result);
      }
    }
  };
  // Prepare map coordinates
  const latitude = Number(selectedSite?.lat);
  const longitude = Number(selectedSite?.lon);
  const validCoords = !isNaN(latitude) && !isNaN(longitude);

  return (
    <>
      {!selectedSite && (
        <div className={styles["overlay"]}>
          <Spinner animation="border" variant="secondary" />
        </div>
      )}
      <div
        className="contentContainer"
        style={{
          padding: "10px",
          backgroundColor: "#ffffff",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      >
        {selectedSite && (
          <Row className="mb-4" style={{ justifyContent: "center" }}>
            {/* First column: Site details table */}
            <Col xs={12} md={isWideScreen ? 4 : 3}>
              <Container
                style={{ maxWidth: "350px", marginLeft: 0, paddingLeft: 0 }}
              >
                <div className="site-details">
                  {/* <div className="section-title">Site Details</div> */}
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th
                          colSpan={2}
                          style={{
                            fontSize: "1.3rem",
                            backgroundColor: "#0071cd",
                            color: "#fff",
                          }}
                        >
                          Site Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* <tr className="small-row">
                                            <td className="fw-bold text-start">Site ID</td>
                                            <td className="text-start">{selectedSite.id}</td>
                                        </tr>
                                        <tr className="small-row">
                                            <td className="fw-bold text-start">Name</td>
                                            <td className="text-start">{selectedSite.name}</td>
                                        </tr> */}
                      <tr className="small-row">
                        <td className="fw-bold text-start">Address One</td>
                        <td className="text-start">
                          {selectedSite.addressOne}
                        </td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">Address Two</td>
                        <td className="text-start">
                          {selectedSite.addressTwo}
                        </td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">City</td>
                        <td className="text-start">{selectedSite.city}</td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">Postal Code</td>
                        <td className="text-start">
                          {selectedSite.postalCode}
                        </td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">State</td>
                        <td className="text-start">{selectedSite.state}</td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">Country</td>
                        <td className="text-start">{selectedSite.country}</td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">Business Region</td>
                        <td className="text-start">
                          {selectedSite.businessRegionName}
                        </td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">Status</td>
                        <td className="text-start">{selectedSite.status}</td>
                      </tr>
                      <tr className="small-row">
                        <td className="fw-bold text-start">Site Type</td>
                        <td className="text-start">{selectedSite.type}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="structure-details">
                  {selectedStructure && (
                    <>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th
                              colSpan={2}
                              style={{
                                fontSize: "1.3rem",
                                backgroundColor: "#0071cd",
                                color: "#fff",
                              }}
                            >
                              Structure Details
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="small-row">
                            <td className="fw-bold text-start">Structure ID</td>
                            <td className="text-start">
                              {selectedStructure.structureId}
                            </td>
                          </tr>
                          <tr className="small-row">
                            <td className="fw-bold text-start">
                              Structure Name
                            </td>
                            <td className="text-start">
                              {selectedStructure.structureName}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </>
                  )}
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "320px",
                    borderRadius: "8px",
                    border: "2px solid #2100b3ff",
                    margin: "16px 0",
                    overflow: "hidden",
                  }}
                >
                  {validCoords && (
                    <Map
                      initialViewState={{
                        longitude,
                        latitude,
                        zoom: 9,
                      }}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "8px",
                      }}
                      mapStyle="mapbox://styles/mapbox/light-v9"
                      mapboxAccessToken={MAPBOX_TOKEN}
                      // dragPan={false}
                      // dragRotate={false}
                      // scrollZoom={false}
                      // doubleClickZoom={false}
                      // touchZoom={false}
                      // touchRotate={false}
                      // keyboard={false}
                    >
                      <Marker longitude={longitude} latitude={latitude} />
                    </Map>
                  )}
                </div>
                {/* <button
                                    type="button"
                                    className="btn btn-primary mb-3"
                                    onClick={() => navigate("/sitecircuitmanagement", { state: { selectedSite } })}
                                >
                                    Back to Site Circuit Management
                                </button> */}
              </Container>
            </Col>
            <Col
              xs={12}
              md={isWideScreen ? 4 : 6}
              className="d-flex flex-column align-items-center"
            >
              <div
                style={{
                  border: "2px solid #0071cd",
                  borderRadius: "8px",
                  padding: "12px 32px",
                  fontWeight: "bold",
                  fontSize: "1.7rem",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  textAlign: "center",
                  // minWidth: "450px",
                  // width: "max-content",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "32px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                    width: "100%",
                  }}
                >
                  {!siteLogoError && (
                    <img
                      src={`/img/${selectedSite.type}.png`}
                      alt={selectedSite.type}
                      style={{
                        height: "40px",
                        width: "40px",
                        objectFit: "contain",
                      }}
                      onError={() => setSiteLogoError(true)}
                    />
                  )}
                  <span
                    style={{ fontWeight: "bold", fontSize: "1.7rem", flex: 1 }}
                  >
                    {selectedSite.siteName} - {selectedSite.siteId}
                  </span>
                  {!siteLogoError && (
                    <img
                      src={`/img/${selectedSite.type}.png`}
                      alt={selectedSite.type}
                      style={{
                        height: "40px",
                        width: "40px",
                        objectFit: "contain",
                      }}
                      onError={() => setSiteLogoError(true)}
                    />
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    width: "100%",
                  }}
                >
                  <Form.Select
                    style={{ minWidth: "220px", fontSize: "1rem" }}
                    value={selectedStructureId}
                    onChange={(e) => setSelectedStructureId(e.target.value)}
                  >
                    <option value="" disabled>
                      Select a Structure
                    </option>
                    {selectedSite.structures &&
                      selectedSite.structures
                        .filter(
                          (structure) =>
                            Array.isArray(structure.circuits) &&
                            structure.circuits.length > 0,
                        )
                        .map((structure) => (
                          <option
                            key={structure.structureId}
                            value={structure.structureId}
                          >
                            {structure.structureName} ({structure.structureId})
                          </option>
                        ))}
                  </Form.Select>
                  {selectedStructure &&
                    selectedSite.structures.filter(
                      (structure) =>
                        Array.isArray(structure.circuits) &&
                        structure.circuits.length > 0,
                    ).length !== 1 && (
                      <Icon
                        name="removeFilter"
                        overrides={{
                          tooltip: "Remove Structure Filter",
                          style: {
                            cursor: "pointer",
                          },
                        }}
                        id="cancel-carrier-icon"
                        onClick={() => setSelectedStructureId("")}
                      />
                    )}
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  justifyContent: "flex-start",
                  maxHeight: "calc(665px)",
                  overflowY: "auto",
                }}
              >
                <CircuitMap
                  circuits={circuits}
                  populateSidePanel={populateSidePanel}
                />
              </div>
            </Col>
            <Col
              xs={12}
              md={isWideScreen ? 4 : 3}
              className="d-flex flex-column align-items-center"
            >
              <Container>
                {selectedCircuit && (
                  <div className="Carrier-details">
                    <div className="section-title">Primary Carrier Details</div>
                    <Table striped bordered hover>
                      <tbody>
                        <tr className="small-row">
                          <td colSpan={2}>
                            {!carrierLogoError ? (
                              <img
                                alt={selectedCircuit.carrier}
                                src={`img/${selectedCircuit.carrier}.png`}
                                style={{
                                  maxHeight: "60px",
                                  maxWidth: "120px",
                                  objectFit: "contain",
                                }}
                                onError={() => setCarrierLogoError(true)}
                              />
                            ) : (
                              <div
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "1.0rem",
                                }}
                              >
                                {selectedCircuit.carrier || "No Carrier"}
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr className="small-row">
                          <td className="fw-bold text-start">Status</td>
                          <td className="text-start">
                            {carrierObj?.status || "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )}
                {selectedCircuit && contacts && contacts.length > 0 && (
                  <div
                    className="Contact-details"
                    style={{ overflowX: "auto", maxWidth: "100%" }}
                  >
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th
                            colSpan={4}
                            style={{
                              fontSize: "1.3rem",
                              backgroundColor: "#0071cd",
                              color: "#fff",
                            }}
                          >
                            All Contacts
                          </th>
                        </tr>
                        <tr>
                          <th>Name</th>
                          <th>Role</th>
                          <th>Phone</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contacts.map((contact, index) => (
                          <tr key={index} className="small-row">
                            <td className="text-start">{contact.name}</td>
                            <td className="text-start">{contact.role}</td>
                            <td className="text-start">{contact.mainPhone}</td>
                            <td className="text-start">{contact.email}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Container>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default SiteMap;
